import api from '../utils/request';
import { extractErrorMessage } from '../utils/apiErrorHandler';

class ProfileAPI {
  static async getProfile(userId) {
    if (!userId) {
      throw new Error('用户ID不能为空');
    }
    
    try {
      const response = await api.get('/profile/', {
        headers: {
          'X-User-Id': Number(userId)
        }
      });
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error) || '获取用户资料失败');
    }
  }

  static async updateProfile(userId, profileData) {
    if (!userId) {
      throw new Error('用户ID不能为空');
    }

    try {
      const response = await api.put('/profile/', profileData, {
        headers: {
          'X-User-Id': Number(userId)
        }
      });
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error) || '更新用户资料失败');
    }
  }
}

export default ProfileAPI;
